import type { ReactNode } from "react";
import { Fox, Wordmark, type FoxMood } from "./Fox.js";
import { auth } from "../copy/auth.js";
import { common } from "../copy/common.js";

/**
 * Shared frame for the signed-out screens. One column on a phone; from lg up the
 * brand moves into its own panel so the form does not sit alone in the middle of
 * a wide screen.
 */
export function AuthLayout({
  mood = "neutral",
  title,
  intro,
  children,
  footer,
}: {
  mood?: FoxMood;
  title: string;
  intro?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="min-h-dvh lg:grid lg:grid-cols-[1.1fr_1fr] xl:grid-cols-[1.2fr_1fr]">
      <section className="hidden flex-col justify-between border-r border-line/70 bg-paper-2/50 px-12 py-12 lg:flex xl:px-16">
        <Wordmark foxClass="h-11 w-11" textClass="text-3xl" />
        <div className="max-w-md">
          <Fox mood="happy" className="mb-8 h-40 w-40" />
          <p className="font-display text-4xl leading-tight xl:text-5xl">{common.tagline}</p>
          <p className="mt-5 text-lg text-ink-soft">{auth.layout.blurb}</p>
        </div>
        <p className="text-sm text-ink-soft">{auth.layout.privacy}</p>
      </section>

      <section className="flex min-h-dvh flex-col justify-center px-5 py-10 sm:px-8 lg:px-12 xl:px-16">
        <div className="mx-auto w-full max-w-md">
          <div className="lg:hidden">
            <Fox mood={mood} className="mx-auto h-24 w-24 sm:h-28 sm:w-28" />
          </div>
          <h1 className="mt-4 text-center text-3xl sm:text-4xl lg:mt-0 lg:text-left">{title}</h1>
          {intro ? (
            <p className="mt-2 text-center text-ink-soft lg:text-left">{intro}</p>
          ) : null}
          <div className="mt-7">{children}</div>
          {footer ? <div className="mt-6">{footer}</div> : null}
        </div>
      </section>
    </div>
  );
}
